import React, {useEffect} from "react";
import s from './home.module.css'
import './components/SvgPlant.css'
import SvgPlant from "./components/SvgPlant";
import FramerPlant from "./components/FramerPlant";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const Home = () => {

    const [isScreenSaver, setIsScreenSaver] = React.useState(true);


/*    useEffect(() => {
        const timer  = setTimeout(() => {
            setIsScreenSaver(false)
        }, 5000)
        return () => clearTimeout(timer)
    }, []);*/

    return (

        <div className={s.main_home_cont}>


        </div>


    )
};

export default Home;